// Region presentation metadata for the world map + breakdown. The 7 broad
// regions mirror app/services/regions.py. Each carries an approximate centroid
// ([lng, lat]) for its map bubble and a distinct colour.
import { REGIONS, type Region } from "@/api/stats-types";

export interface RegionMeta {
  region: Region;
  short: string;
  center: [number, number]; // [lng, lat]
  color: string;
}

export const REGION_META: Record<Region, RegionMeta> = {
  "North America": { region: "North America", short: "N. America", center: [-100, 45], color: "#2563eb" },
  "Latin America": { region: "Latin America", short: "Lat. America", center: [-63, -17], color: "#db2777" },
  Europe: { region: "Europe", short: "Europe", center: [12, 50], color: "#7c3aed" },
  "Middle East & Africa": { region: "Middle East & Africa", short: "MEA", center: [25, 8], color: "#d97706" },
  "South Asia": { region: "South Asia", short: "S. Asia", center: [78, 22], color: "#059669" },
  "East Asia & Pacific": { region: "East Asia & Pacific", short: "E. Asia/Pac.", center: [113, 22], color: "#0891b2" },
  Oceania: { region: "Oceania", short: "Oceania", center: [140, -27], color: "#65a30d" },
};

export const REGION_LIST = REGIONS.map((r) => REGION_META[r]);
